

export { CEvoDocNumber } from '../../fragments/c-evo-doc-number'
